import { logInLogoIcon } from "../assets";


export const colorOptions = [
    { value: '#1976d2', label: 'Royal Blue', class: 'primary' },
    { value: '#dc004e', label: 'Rose Pink', class: 'secondary' },
    { value: '#4caf50', label: 'Forest Green', class: 'success' },
    { value: '#ff9800', label: 'Sunset Orange', class: 'warning' },
    { value: '#f44336', label: 'Crimson Red', class: 'error' },
    { value: '#9c27b0', label: 'Deep Purple', class: 'purple' },
    { value: '#00bcd4', label: 'Ocean Cyan', class: 'cyan' },
    { value: '#795548', label: 'Warm Brown', class: 'brown' },
    { value: '#607d8b', label: 'Steel Blue', class: 'blue-grey' },
    { value: '#e91e63', label: 'Fuchsia Pink', class: 'pink' },
    { value: '#009688', label: 'Teal Green', class: 'teal' },
    { value: '#ffc107', label: 'Golden Amber', class: 'golden' },
    { value: '#3f51b5', label: 'Indigo', class: 'indigo' },
    { value: '#ff5722', label: 'Burnt Orange', class: 'burnt-orange' },
    { value: '#8bc34a', label: 'Lime Green', class: 'lime' },
];




// src/utils/staffData.js

export const staffCategories = [
    {
        id: 1,
        category: "Triage",
        subCategories: [
            "Triage",
        ]
    },
    {
        id: 2,
        category: "Store Keeping",
        subCategories: [
            "Store keeper",
        ]
    },
    {
        id: 3,
        category: "Accounting",
        subCategories: [
            "Cashier",
            "Accountant",
        ]
    },
    {
        id: 4,
        category: "Pharmacy",
        subCategories: [
            "Pharmacist",
        ]
    },
    {
        id: 5,
        category: "Laboratory",
        subCategories: [
            "Laboratorist",
        ]
    },
    {
        id: 6,
        category: "Radiography",
        subCategories: [
            "Radiographer",
        ]
    },
    {
        id: 7,
        category: "Doctor",
        subCategories: [
            "General Practitioners",
            "Specialists",
            "Surgeons"
        ]
    },
    {
        id: 8,
        category: "Nurses",
        subCategories: [
            "Biorate Nurse",
            "Registered Nurses",
            "Enrolled Nurses"
        ]
    },
        {
        id: 9,
        category: "Other",
        subCategories: [
            "Clinical Officers",
            "Medical Interns",
            "Midwives",
        ]
    },
];

// Helper function to get sub-categories by category ID
export const getSubCategoriesByCategoryId = (categoryId) => {
    const category = staffCategories.find(cat => cat.id === categoryId);
    return category ? category.subCategories : [];
};

// Helper function to get category by ID
export const getCategoryById = (categoryId) => {
    return staffCategories.find(cat => cat.id === categoryId);
};
export const companyInfo = {
        name: "HMS",
        address: "Apac District",
        phone: "0701243139",
        email: "hotel@gmail.com",
        logo: logInLogoIcon,
        website: "www.hotel.com",
        receiptFooter: "Thank you for your business! Please come again."
    };



export const developerInfo = {
        name: "mogasoft",
        package: "HMS",
        webSite: "www.mogasoft.com",
        version: "1.0.0"
    };